import { render, staticRenderFns } from "./MainHead.vue?vue&type=template&id=72ccbf5e&"
import script from "./MainHead.vue?vue&type=script&lang=js&"
export * from "./MainHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports